export class EntityData {
  count: number
  pages: number
  pageSize: number
  data: any[]
  footer: any[]
  maxActionNumber: number
  page: number
  type: string

  constructor(
    data?: any[],
    type?: string,
    count?: number,
    pages?: number,
    pageSize?: number,
    maxActionNumber?: number,
    page?: number
  ) {
    this.data = data
    this.type = type
    this.count = count
    this.pages = pages
    this.pageSize = pageSize
    this.maxActionNumber = maxActionNumber
    this.page = page
  }
}

export class Entity {
  type: string
  // this is no array but a map or record or object
  // fields: any[];
  // type could also be Record<string, any>
  fields: object
}
